module.exports = __webpack_public_path__ + "static/media/ymky.4cfa272f.png";